export const loaderConfig = {
  fgsColor: "#585D6A",
  pbColor: "#585D6A",
  bgsOpacity: "0.6",
  bgsType: "fading-circle",
  fgsType: "double-bounce",
  fgsSize: 90,
  pbThickness: 7,
  overlayColor: "rgba(40,40,40,0)"
};
